/**
 * ssssssssssssssssssnakeify a string
 * @param inputString
 * @returns {string}
 */
export const useSnakeCase = (inputString) => {
    if (typeof(inputString) !== 'string') return '';
    const words = inputString.toLowerCase().trim().split(/[\s_-]+/g);
    return words.join('_');
}